import { render, staticRenderFns } from "./doingComplaint.vue?vue&type=template&id=3ccb42e2&scoped=true"
import script from "./doingComplaint.vue?vue&type=script&lang=js"
export * from "./doingComplaint.vue?vue&type=script&lang=js"
import style0 from "./doingComplaint.vue?vue&type=style&index=0&id=3ccb42e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccb42e2",
  null
  
)

export default component.exports